import { fetcher } from "helpers/fetcher";

import { TGetStaffInsuranceReq, TGetStaffInsuranceRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getStaffInsurance = async (payload: TGetStaffInsuranceReq) => {
  return await fetcher<TGetStaffInsuranceRes, TGetStaffInsuranceReq["data"]>(
    ENDPOINT.USER.GET_STAFF_INSURANCE,
    {
      data: payload.data,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.GET_STAFF_INSURANCE.version,
        [API_HEADER.USER_ID]: payload.idUser,
      },
    }
  );
};

export const queryGetStaffInsurance = async (
  payload: TGetStaffInsuranceReq
) => {
  return (await getStaffInsurance(payload)).data;
};

queryGetStaffInsurance._key = (payload: TGetStaffInsuranceReq) => [
  ENDPOINT.USER.GET_STAFF_INSURANCE.url,
  payload,
];
